import { render, staticRenderFns } from "./MenuAdministrativo.vue?vue&type=template&id=9a9a5af4"
import script from "./MenuAdministrativo.vue?vue&type=script&lang=js"
export * from "./MenuAdministrativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports